import React, { Component } from 'react';
import WorkEnquiryForm from 'components/forms/WorkEnquiryForm.js';
import ContactSubNav from 'components/navigation/ContactSubNav';

import { Container } from 'theme/Grid';

class WorkWithMePage extends Component {

  constructor(props, context) {
    super(props, context);
    this.state = {
      formData: {
        name: '',
        email: '',
        services: '',
        details: '',
        _gotcha: ''
      },
      formSending: false,
      formSubmitSuccess: false,
      formSubmitError: false
    };

    this.onFormChange = this.onFormChange.bind(this);
    this.submitForm = this.submitForm.bind(this);
  }

  onFormChange(name, value) {
    let newFormData = this.state.formData;
    newFormData[name] = value;
    this.setState({
      formData: newFormData
    });
  }

  submitForm(e) {
    e.preventDefault();
    let component = this;

    if(component.state.formData._gotcha !== '')
      return;

    component.setState({formSending: true});

    fetch('https://stoz8ctrp1.execute-api.eu-west-2.amazonaws.com/live/email/work-with-me', {
      method: 'post',
      mode: 'cors',
      headers: new Headers({
        'Content-Type': 'application/json',
        'X-Api-Key': 'tXH09Jc75a10tOxNk1nxA4etxvsZSstSPxpsydVc'
      }),
      body: JSON.stringify(component.state.formData)
    }).then(function(response) {
      if (response.status !== 200) {
        console.log('Looks like there was a problem. Status Code: ' + response.status);
        component.setState({
          formSubmitError: true,
          formSubmitSuccess: false,
          formSending: false
        });
        return;
      }
      response.json().then(function(data) {
        console.log('response: ' + data);
      });
      component.setState({
        formSubmitError: false,
        formSubmitSuccess: true,
        formSending: false
      });
    }
    ).catch(function() {
      component.setState({
        formSubmitError: true,
        formSubmitSuccess: false,
        formSending: false
      });
    });
  }

  render() {
    return (
      <Container className='contact-page'>
          <ContactSubNav />
          <WorkEnquiryForm
            formSending={this.state.formSending}
            formSubmitSuccess={this.state.formSubmitSuccess}
            formSubmitError={this.state.formSubmitError}
            submitForm={this.submitForm}
            onFormChange={this.onFormChange} />
      </Container>
    );
  }

}

export default WorkWithMePage;



// WEBPACK FOOTER //
// ./src/containers/WorkWithMePage.js